// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export class Constants {
  // Project configurations
  static MAXIMUM_LENGTH_OF_NAME = 30;
  // Keyboard keys
  static ENTER_KEY = 13;
  // Max mobile devices' width
  static MAXIMUM_WINDOW_WIDTH = 680;
  // Privacy statement link
  static PRIVACY_STATEMNT_LINK = 'https://privacy.microsoft.com/en-US/data-privacy-notice';
  // App Center link download UI Library Sample Android App
  static ANDROID_APPCENTER_LINK =
    'https://install.appcenter.ms/orgs/Azure-Communication-Services/apps/Azure-Communication-Services-Call-UI-Library-Sample-Android-Internal';
  // App Center link download UI Library Sample iOS App
  static IOS_APPCENTER_LINK =
    'https://install.appcenter.ms/orgs/Azure-Communication-Services/apps/Azure-Communication-Services-Call-UI-Library-Sample-iOS-Internal';

  // Screen names
  static SCREENS = {
    CALENDAR: 'Calendar',
    CREATE: 'Create ACS Meeting',
    LOBBY: 'Lobby',
    MEETING: 'Meeting',
    JOIN: 'Join Teams Meeting'
  };
  // Teams meeting link prefix
  static TEAMS_MEETING_LINK_PREFIX = 'https://teams.microsoft.com/l/meetup-join/';
  // Teams meeting link indicator
  static TEAMS_MEETING_LINK_INDICATOR = 'teamsMeetingLink';
  // ACS meeting chat thread Id parameter
  static ACS_CHAT_PARAM_NAME = 'threadId';
  // ACS meeting group call Id parameter
  static ACS_CALL_PARAM_NAME = 'groupId';
  // ACS meeting link (ACS chat and call)
  static ACS_GROUPCALL_CHAT_PATTERN = [
    /https:\/\/delightful-dune-06c84ff1e.3.azurestaticapps.net\/\?threadId=[\w:@.-]+&(amp;)?groupId=[\w-]+/,
    /https:\/\/azurecomm-selfhost.net\/\?threadId=[\w:@.-]+&(amp;)?groupId=[\w-]+/
  ];
  // Error Message Header
  static ERROR_MESSAGE_HEADER = {
    CALENDAR: 'Failed to render the calendar page:',
    MEETING: 'Failed to join meeting:'
  };
}
